var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3DRotate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.58398 7.71655L10.0006 10.2749L14.384 7.73322",
    stroke: "#ED3A3A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.001 14.8083V10.2666",
    stroke: "#ED3A3A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.96688 5.24163L6.3002 6.72496C5.7002 7.05829 5.2002 7.89996 5.2002 8.59163V11.4166C5.2002 12.1083 5.69187 12.95 6.3002 13.2833L8.96688 14.7666C9.53354 15.0833 10.4669 15.0833 11.0419 14.7666L13.7085 13.2833C14.3085 12.95 14.8085 12.1083 14.8085 11.4166V8.5833C14.8085 7.89163 14.3169 7.04996 13.7085 6.71663L11.0419 5.23329C10.4669 4.91663 9.53354 4.91663 8.96688 5.24163Z",
    stroke: "#ED3A3A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 12.5C18.3333 15.725 15.725 18.3333 12.5 18.3333L13.375 16.875",
    stroke: "#ED3A3A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66699 7.50008C1.66699 4.27508 4.27533 1.66675 7.50033 1.66675L6.62534 3.12508",
    stroke: "#ED3A3A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3DRotate);
export default __webpack_public_path__ + "static/media/3d-rotate.3aab2d04b467b011b6c0a3e14ad2d7ed.svg";
export { ForwardRef as ReactComponent };